import { withViewModel } from '../../../infrastructure/components/with-view-model';
import complainceEmailsFormPresentation from './complaince-emails-form.presentation';
import ComplianceEmailsFormVM from './complaince-emails-form.viewmodel';

interface IProps {
    vm: ComplianceEmailsFormVM;
}

const ComplianceEmailsFormContainer = withViewModel(
    complainceEmailsFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { ComplianceEmailsFormContainer as ComplianceEmailsForm };
